// client/src/pages/StockPage.js
import React from 'react';
import StockDetail from '../components/StockDetail';

function StockDetailPage() {
  return <StockDetail />;
}

export default StockDetailPage;
